import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, BookOpen, Download, Gamepad2, PencilRuler } from "lucide-react";

const cards = [
  { title:"Alap Bayt", text:"Ancient Abaryt letter learning with pictographs, sounds, numbers and simple memory prompts.", href:"/free-resources/alap-bayt", icon:BookOpen, live:true },
  { title:"Print & Learn", text:"Printable practice pages, tracing, matching and review sheets will live here.", icon:Download },
  { title:"Games", text:"Memory games, matching rounds, letter hunts and learning challenges will live here.", icon:Gamepad2 },
  { title:"Make & Do", text:"Hands-on projects that connect Turah, Abaryt and everyday learning.", icon:PencilRuler },
];

export default function YaHuaHsGirlsActivities(){
  return <div className="min-h-screen bg-[#fff8ed]" data-testid="yah-girls-activities-page">
    <section className="bg-royal-blue py-14 text-white">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <Link to="/YaHsgirls" className="inline-flex items-center text-sm font-bold text-kingdom-gold"><ArrowLeft className="mr-2 h-4 w-4"/>YaHUaH&apos;s Girls</Link>
        <h1 className="mt-5 font-heading text-4xl font-black sm:text-5xl">Activities</h1>
        <p className="mt-3 max-w-2xl text-white/80">Print, play, practice and build. YaHUaH&apos;s Girls activities now pull from the shared Free Resources library.</p>
      </div>
    </section>
    <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="grid gap-5 md:grid-cols-2">
        {cards.map(({title,text,href,icon:Icon,live})=>{
          const content=<><div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-kingdom-gold/15 text-royal-blue"><Icon className="h-6 w-6"/></div><div className="mt-4 flex items-center gap-2"><h2 className="font-heading text-2xl font-black text-royal-blue">{title}</h2>{live?<span className="bg-kingdom-gold px-2 py-1 text-[10px] font-black uppercase text-royal-blue">Open</span>:<span className="bg-slate-100 px-2 py-1 text-[10px] font-black uppercase text-slate-500">Coming</span>}</div><p className="mt-2 text-slate-600">{text}</p>{href&&<span className="mt-5 inline-flex items-center font-bold text-royal-blue">Open <ArrowRight className="ml-2 h-4 w-4"/></span>}</>;
          return href?<Link key={title} to={href} className="bg-white p-7 shadow-sm ring-1 ring-black/5 hover:-translate-y-1 transition-transform">{content}</Link>:<div key={title} className="bg-white p-7 shadow-sm ring-1 ring-black/5">{content}</div>
        })}
      </div>
    </section>
    <section className="mx-auto max-w-6xl px-4 pb-12 sm:px-6 lg:px-8">
      <Link to="/free-resources" className="inline-flex min-h-11 items-center justify-center bg-royal-blue px-5 py-3 font-bold text-white">
        Browse all Free Resources <ArrowRight className="ml-2 h-4 w-4"/>
      </Link>
    </section>
  </div>
}
